export enum Tabs {
  MEDIA_NODE_PROJECT = "media-node-project",
  ACTION = "action",
  LAYER = "layer",
  INSPECTOR = "inspector",
  SETTINGS = "settings",
}
